import React from 'react';
import { useField } from 'formik';

import { BaseSelect } from '../shared/BaseSelect/BaseSelect';

import styles from './FormikSelectInput.module.scss';

export const FormikSelectInput = ({
  name,
  options,
  label,
  placeholder,
  isRequired,
  isClearable = true,
  shouldDisplayLabel = true,
  ...props
}) => {
  const [field, meta, helpers] = useField(name);

  return (
    <div className={styles.container}>
      {shouldDisplayLabel && (
        <label htmlFor={name} className={styles.label}>
          {label} {isRequired && <span className={styles.required}>*</span>}
        </label>
      )}
      <BaseSelect
        {...meta}
        placeholder={placeholder}
        onChange={(option) => helpers.setValue(option?.value || null)}
        value={options.find((opt) => opt.value === field.value) || null}
        options={options}
        isClearable={isClearable}
        menuMaxHeight="300px"
        hasError={meta.touched && meta.error}
        {...props}
      />
      {meta.touched && meta.error && <div className={styles.errorMessage}>{meta.error}</div>}
    </div>
  );
};
